import * as React from "react";
import { getAuthUserId } from "../auth/session.js";
import { gameRequest } from "./game-api.js";

export function useEventPayments(preview, onPaid) {
  const key = `king-hill-payment:${getAuthUserId()}`;
  const [pending, setPending] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [notice, setNotice] = React.useState("");
  const busyRef = React.useRef(false);
  React.useEffect(() => {
    if (preview) return;
    const url=new URL(location.href), returned=url.searchParams.get("kh_order");
    try {
      if (/^[a-f0-9]{32}$/.test(returned || "")) { localStorage.setItem(key,returned); url.searchParams.delete("kh_order"); history.replaceState(history.state,"",url); }
      setPending(localStorage.getItem(key));
    } catch { setNotice("Разрешите локальное хранение для восстановления статуса оплаты."); }
  },[key,preview]);
  React.useEffect(() => {
    if (!pending || preview) return;
    let active=true, checking=false;
    async function check() {
      if (checking || document.hidden) return;
      checking=true;
      try {
        const result=await gameRequest("payment",{paymentId:pending});
        if (!active) return;
        if(result.paid || result.failed || result.refunded) {
          localStorage.removeItem(key); setPending(null);
          setNotice(result.refunded ? "Оплата возвращена: покупка уже недоступна." : result.paid ? "Покупка выдана." : "Оплата отменена или срок счёта истёк.");
          if(result.paid) onPaid();
        } else setNotice(result.refundPending ? "Возврат оплаты обрабатывается." : "Ожидаем подтверждение оплаты…");
      } catch { /* Retain the order: a network timeout does not cancel payment. */ }
      finally {checking=false;}
    }
    check(); const timer=setInterval(check,4000);
    window.addEventListener("focus",check); document.addEventListener("visibilitychange",check);
    return ()=>{active=false;clearInterval(timer);window.removeEventListener("focus",check);document.removeEventListener("visibilitychange",check);};
  },[pending,key,preview,onPaid]);
  async function buy(product,currency,email="") {
    if(preview || busyRef.current || pending) return;
    const tg=window.Telegram?.WebApp;
    if(currency==="XTR" && !tg?.openInvoice) {setNotice("Оплата Stars доступна внутри Telegram.");return;}
    const popup=currency==="RUB" && !tg?.openLink ? window.open("about:blank","_blank") : null;
    if(popup) popup.opener=null;
    busyRef.current=true; setBusy(true); setNotice("");
    try {
      // Verify storage before creating an order, so it can survive app closure.
      localStorage.setItem(key+":check","1"); localStorage.removeItem(key+":check");
      const result=await gameRequest("buy",{product,currency,email});
      if(!/^[a-f0-9]{32}$/.test(result.paymentId || "")) throw new Error("Не удалось создать платёж.");
      localStorage.setItem(key,result.paymentId); setPending(result.paymentId);
      if(currency==="XTR") {
        tg.openInvoice(result.invoiceLink,async status=>{
          if(status==="cancelled" || status==="failed") {
            try {await gameRequest("cancel-payment",{paymentId:result.paymentId});} catch { /* Poll the authoritative order status. */ }
          }
        });
      } else if(tg?.openLink) tg.openLink(result.paymentUrl);
      else if(popup) popup.location.replace(result.paymentUrl);
      else location.assign(result.paymentUrl);
    } catch(error) {popup?.close();setNotice(error.message || "Оплата временно недоступна.");}
    finally {busyRef.current=false;setBusy(false);}
  }
  return {buy,busy:busy || !!pending,notice};
}
